import React from 'react';
import { StyledCloseButton } from './StyledComponents';
import { CloseSmIcon } from '../Spots';
import type { AtomicEventsAttributes } from '@/lib/atomics';

interface CloseButtonProps {
  atomicEventsAttributes?: AtomicEventsAttributes;
  onClick: () => void;
  [key: string]: string | React.ReactNode;
}

export const CloseButton = ({
  atomicEventsAttributes,
  onClick,
  ...rest
}: CloseButtonProps): React.ReactElement => {
  return (
    <StyledCloseButton
      data-testid="close-button"
      iconComponent={CloseSmIcon}
      onClick={onClick}
      data-atomic-wait-domain={atomicEventsAttributes?.domain}
      data-atomic-wait-flow={atomicEventsAttributes?.flow}
      data-atomic-wait-intent={atomicEventsAttributes?.intent}
      data-atomic-wait-task={atomicEventsAttributes?.task}
      data-atomic-wait-viewname={atomicEventsAttributes?.viewName}
      tertiary
      {...rest}
    />
  );
};
